export const CARD_LOCATION_PAGE_TYPES = {
  dashboard: 'dashboard',
  coins: 'coins',
  ContentFeed: 'ContentFeed',
  Article: 'Article',
  StartPage: 'StartPage',
  ResultPage: 'ResultPage'
};
